"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _CheckboxStyled = require("./CheckboxStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Checkbox = _ref => {
  let {
    children,
    onClickFn,
    error,
    checked,
    required,
    isMyAccount,
    className,
    disabled,
    isRadioButton,
    termsUrl,
    isPayPal
  } = _ref;
  const [isChecked, setIsChecked] = (0, _react.useState)(checked);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  (0, _react.useEffect)(() => {
    setIsChecked(checked);
  }, [checked]);
  const spaceKey = ' ';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_CheckboxStyled.CheckboxStyled, {
      onClick: e => {
        e.stopPropagation();
        onClickFn(e, disabled, setIsChecked);
      },
      role: "checkbox",
      tabIndex: "-1",
      "aria-checked": isChecked,
      checked: isChecked,
      "aria-label": children,
      className: className,
      disabled: disabled,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxStyled.CheckFrameStyled, {
        error: error && required && !isChecked,
        tabIndex: "0",
        onKeyDown: e => e.key === spaceKey ? onClickFn() : null,
        isMyAccount: isMyAccount,
        isRadioButton: isRadioButton,
        checked: isChecked,
        children: isChecked && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxStyled.CheckMarkStyled, {
          "data-testid": "checkmark",
          isMyAccount: isMyAccount,
          isRadioButton: isRadioButton
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxStyled.ConsentDefinitionStyled, {
        dangerouslySetInnerHTML: {
          __html: "".concat(children).concat(required && isMyAccount ? '*' : '')
        },
        checked: isChecked
      })]
    }), termsUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxStyled.TermsLinkStyled, {
      href: termsUrl,
      target: "_blank",
      rel: "noreferrer",
      checked: isChecked,
      $isPayPal: isPayPal,
      children: t('Terms & Conditions')
    })]
  });
};
Checkbox.propTypes = {
  checked: _propTypes.default.bool,
  required: _propTypes.default.bool,
  onClickFn: _propTypes.default.func,
  error: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  isMyAccount: _propTypes.default.bool,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  isRadioButton: _propTypes.default.bool,
  termsUrl: _propTypes.default.string,
  isPayPal: _propTypes.default.bool
};
Checkbox.defaultProps = {
  error: '',
  checked: false,
  required: false,
  onClickFn: t => t,
  children: '',
  isMyAccount: false,
  className: '',
  disabled: false,
  isRadioButton: false,
  termsUrl: '',
  isPayPal: false
};
var _default = exports.default = Checkbox;